module.exports = __webpack_public_path__ + "media/images/places/espaco-cultural-jardim-damasceno-ecjd-e2b1e969705ef405d2180fd58fb4fe19.jpg";